(function () {
  'use strict';
  if (window.__bhQuickAdd) return;
  window.__bhQuickAdd = true;

  var HIT = 52; // px square in the card's bottom / inline-end corner that counts as the "+" (the glyph itself is 32px)
  var busy = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function inCorner(card, event) {
    var r = card.getBoundingClientRect();
    var rtl = getComputedStyle(card).direction === 'rtl';
    var nearEnd = rtl ? event.clientX - r.left <= HIT : r.right - event.clientX <= HIT;
    return nearEnd && r.bottom - event.clientY <= HIT;
  }

  function add(variantId, el) {
    if (busy) return;
    busy = true;
    el.classList.add('bh-quick-add--busy');
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { id: Number(variantId), quantity: 1 }; // single-line form: the response is the line item itself
    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    })
      .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
      .then(function (out) {
        if (!out.ok || out.json.status) throw new Error(out.json.description || out.json.message || 'add failed');
        if (cart && cart.renderContents && out.json.sections) {
          if (cart.setActiveElement) cart.setActiveElement(el);
          cart.renderContents(out.json);
        }
        if (window.CartChannel) {
          fetch(root() + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
            window.CartChannel.postMessage(String(c.item_count));
          });
        }
        el.classList.add('bh-quick-add--done');
        setTimeout(function () { el.classList.remove('bh-quick-add--done'); }, 1400);
      })
      .catch(function () {
        window.location.href = el.getAttribute('href') || el.getAttribute('data-bh-url') || root();
      })
      .then(function () {
        busy = false;
        el.classList.remove('bh-quick-add--busy');
      });
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;
    var target = event.target;
    if (!target || !target.closest) return;

    var go = target.closest('[data-bh-go]');
    if (go) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.href = go.getAttribute('data-bh-go');
      return;
    }

    var el = target.closest('[data-bh-quick-add]');
    if (!el) return;
    var wholeButton = el.classList.contains('bh-view-product');
    if (!wholeButton && !inCorner(el, event)) return; // the rest of a home card still opens the product
    event.preventDefault();
    event.stopImmediatePropagation();
    add(el.getAttribute('data-bh-quick-add'), el);
  }, true);
})();
